// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"fb056529bd39d3193d9d","678":"0450651244308f9d189f","883":"13d0a10650933820f5b6"}[chunkId] + ".js";
};